import { render, staticRenderFns } from "./textual-address.vue?vue&type=template&id=268b30bc&"
import script from "./textual-address.vue?vue&type=script&lang=js&"
export * from "./textual-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports